import { USERS } from "../lib/constants/actions";



export const getUsers = (data) => {
    return {
        type: USERS.GET_USERS,
        payload: data
    }
}

export const getUsersSuccess = (data) => {
    return {
        type: USERS.GET_USERS_SUCCESS,
        payload: data
    }
}



export const getReportUsers = (data) => {
    return {
        type: USERS.GET_REPORT_USERS,
        payload: data
    }
}

export const getReportUsersSuccess = (data) => {
    return {
        type: USERS.REPORT_USERS_SUCCESS,
        payload: data
    }
}

export const getAdminUsers = (data) => {
    return {
        type: USERS.GET_ADMIN_USERS,
        payload: data
    }
}

export const getAdminUsersSuccess = (data) => {
    return {
        type: USERS.GET_ADMIN_USERS_SUCCESS,
        payload: data
    }
}


export const getUserProfile = (data) => {
    return {
        type: USERS.GET_USER_PROFILE,
        payload: data
    }
}

export const getUserProfileSuccess = (data) => {
    return {
        type: USERS.USER_PROFILE_SUCCESS,
        payload: data
    }
}


export const suspendAccount = (data) => {
    return {
        type: USERS.SUSPEND_ACCOUNT,
        payload: data
    }
}
export const suspendAccountSuccess = (data) => {
    return {
        type: USERS.SUSPEND_ACCOUNT_SUCCESS,
        payload: data
    }
}

export const updateProfile = (data) => {
    return {
        type: USERS.UPDATE_PROFILE,
        payload: data
    }
}
export const updateProfileSuccess = (data) => {
    return {
        type: USERS.UPDATE_PROFILE_SUCCESS,
        payload: data
    }
}

export const addUser = (data) => {
    return {
        type: USERS.ADD_USER,
        payload: data
    }
}
export const addUserSuccess = (data) => {
    return {
        type: USERS.ADD_USER_SUCCESS,
        payload: data
    }
}



export const getUsersLocations = (data) => { return { type: USERS.GET_USERS_LOCATIONS, payload: data }}
export const getUsersLocationsSuccess = (data) => { return { type: USERS.GET_USERS_LOCATIONS_SUCCESS, payload: data }}


export const getFollowers = (data) => { return { type: USERS.GET_FOLLOWERS, payload: data }}
export const getFollowersSuccess = (data) => { return { type: USERS.GET_FOLLOWERS_SUCCESS, payload: data }}

export const getFollowing = (data) => { return { type: USERS.GET_FOLLOWING, payload: data }}
export const getFollowingSuccess = (data) => { return { type: USERS.GET_FOLLOWING_SUCCESS, payload: data }}

export const changeAppPassword = (data) => { return { type: USERS.CHANGE_APP_PASSWORD, payload: data }}
export const changeAppPasswordSuccess = (data) => { return { type: USERS.CHANGE_APP_PASSWORD_SUCCESS, payload: data }}

export const updateAutoFollow = (data) => { return { type: USERS.UPDATE_AUTO_FOLLOW, payload: data }}
export const updateAutoFollowSuccess = (data) => { return { type: USERS.UPDATE_AUTO_FOLLOW_SUCCESS, payload: data }}


export const getDeletedUsers = (data) => { return { type: USERS.GET_DELETED_USERS, payload: data } }
export const getDeletedUsersSuccess = (data) => { return { type: USERS.GET_DELETED_USERS_SUCCESS, payload: data } }

export const changeAdvertiseStatus = (data) => { return { type: USERS.CHANGE_ADVERTISE_STATUS, payload: data } }
export const changeAdvertiseStatusSuccess = (data) => { return { type: USERS.CHANGE_ADVERTISE_STATUS_SUCCESS, payload: data } }






